import React from 'react';
import { mockHowToPlay } from '../mock';
import { Wallet, MapPin, Sprout, Coins } from 'lucide-react';

const iconMap = {
  1: Wallet,
  2: MapPin,
  3: Sprout,
  4: Coins
};

const HowToPlay = () => {
  return (
    <section id="how-to-play" className="bg-[#121212] py-20">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        <div className="text-center mb-16">
          <h2 className="text-[48px] font-semibold leading-[1.1] tracking-[-0.02em] text-white mb-4">
            How to Get Started
          </h2>
          <p className="text-[20px] font-medium leading-[1.5] text-[rgba(255,255,255,0.85)] max-w-2xl mx-auto">
            Start earning in just 4 simple steps
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {mockHowToPlay.map((step) => {
            const IconComponent = iconMap[step.step];
            return (
              <div
                key={step.step}
                className="relative border border-[rgba(255,255,255,0.25)] bg-black p-8 hover:border-[#00FFD1] transition-all duration-400"
              >
                {/* Step Number */}
                <div className="absolute top-4 right-4 text-[48px] font-bold text-[rgba(0,255,209,0.2)]">
                  {step.step}
                </div>

                <div className="relative z-10">
                  <div className="w-16 h-16 bg-[#00FFD1] flex items-center justify-center mb-6">
                    {IconComponent && <IconComponent className="w-8 h-8 text-black" />}
                  </div>
                  <h3 className="text-[24px] font-semibold leading-[1.3] text-white mb-3">
                    {step.title}
                  </h3>
                  <p className="text-[16px] font-normal leading-[1.4] text-[rgba(255,255,255,0.85)]">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowToPlay;
